(function () {
	const passwordeye = () => {
		const toggleButton = document.querySelector(".field__password-type");
		const passwordInput = document.getElementById("CustomerPassword");

		toggleButton.addEventListener("click", function () {
			if (passwordInput.type === "password") {
				passwordInput.type = "text";
			} else {
				passwordInput.type = "password";
			}
		});
	};

	const displayTaxIdField = () => {
		let customerTypeSelect = document.getElementById("RegisterForm-Customer_Type");
		let taxIdField = document.getElementById("registration-tax-id");

		customerTypeSelect.addEventListener("change", function (event) {
			if (this.value !== "General") {
				taxIdField.classList.remove('hidden');
			} else {
				taxIdField.classList.add('hidden');
			}
		});
	};

	passwordeye();
	displayTaxIdField();
	document.addEventListener("shopify:section:load", function () {
		passwordeye();
		displayTaxIdField();
	});
})();
